// src/Utils/tagIcons.js

// 1) Keys → Titles (no image imports here)
// src/Utils/tagIcons.js
export const TAG_TITLES = {
  // isNewUser: "New User",
  /** Keys must match BOOKING_TAG_ICONS / booking tag flags (e.g. `China`, not `china`) */
  China: "China",
  thai: "Thai",
  malaysian: "Malaysian",
  singapore: "Singapore",
  indonesian: "Indonesian",
  male: "Male",
  female: "Female",
  soft: "Soft",
  hard: "Hard",
  natal: "Pre-Natal Massage",
  slimming: "Slimming Therapy",
  repeat: "Booking is repeating",

  // 🔹 dynamic ones
  isRequested: (extraData) => extraData.therapist,

  haveNotes: (extraData) => extraData?.note,
  hasWebNotes: (extraData) => extraData?.webNotes,

  hasRequestedRoom: (extraData) => extraData?.room || extraData?.room,
  // isNewUser: (extraData) => extraData?.userName && extraData?.userNumber,
  bookingThrough: "Web Booking",
};


const canonicalTagKey = (raw) => {
  const lower = String(raw).trim().toLowerCase();
  if (!lower) return null;
  // `China` is the only nationality tag with a capital key in TAG_TITLES / BOOKING_TAG_ICONS
  if (lower === "china") return "China";
  return lower;
};

// 2) Accept tags as object, array, or comma-separated string (keys lowercased)
export const normalizeTags = (tags) => {
  if (!tags) return {};
  if (typeof tags === "string") {
    return tags.split(",").reduce((acc, raw) => {
      const key = canonicalTagKey(raw);
      if (key) acc[key] = true;
      return acc;
    }, {});
  }
  if (Array.isArray(tags)) {
    return tags.reduce((acc, raw) => {
      const key = canonicalTagKey(raw);
      if (key) acc[key] = true;
      return acc;
    }, {});
  }
  // Preserve object keys as-is (e.g. haveNotes, hasWebNotes, isRequested)
  return tags;
};

// 3) Build icons list using an injected icon registry
export const buildTagIcons = (tags, iconRegistry = {}, extraData = {}) => {
  const active = normalizeTags(tags);
  return Object.keys(TAG_TITLES)
    .filter((key) => active[key])
    .map((key) => {
      const title =
        typeof TAG_TITLES[key] === "function"
          ? TAG_TITLES[key](extraData) // pass all dynamic data
          : TAG_TITLES[key];

      return {
        icon: iconRegistry[key],
        title,
      };
    })
    .filter((x) => x.icon); // only keep ones that have an icon
};

